<template>
	<el-dialog title="不通过" :visible.sync="dialogVisible" width="30%" append-to-body :before-close="resetForm">
		<el-form :model="form" :rules="rules" ref="form" label-width="80px">
			<el-form-item label="原因" prop="reason">
				<el-input type="textarea" v-model="form.reason" placeholder="输入不通过原因，必填"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="resetForm">取 消</el-button>
			<el-button type="primary" @click="confirmHandle">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import refunds from '@/services/finance/refunds'
export default {
	data () {
		return {
			dialogVisible: false,
			form: {
				reason: '',
			},
			rowId: '',
			rules: {
				reason: [
					{ required: true, message: '请输入拒绝原因', trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		openModal (id) {
			this.rowId = id;
			this.dialogVisible = true;
		},
		confirmHandle () {
			this.$refs.form.validate(async valid => {
				if (valid) {
					const { code, message } = await refunds.refundReject({ id: this.rowId, ...this.form });
					if (Object.is(code, 0)) {
						this.$message.success(message);
						this.$emit('loadData', 1);
						this.resetForm();
					} else {
						this.$message.error(message);
					}
				}
			})
		},
		resetForm () {
			this.$refs.form.resetFields();
			this.dialogVisible = false;
		}
	}
}
</script>
